import { gql } from '@apollo/client';

export const REMOVE_OPTION_FROM_MULTI_RESPONSE = gql`
  mutation removeOptionFromMultiResponse($responseId: Int!) {
    customField {
      removeOptionIntoMultiResponse(responseId: $responseId) 
    }
  }
`;
